module.exports = __webpack_public_path__ + "img/very_high_income.105c75fd.svg";